
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"individual 44x44"}},[_c('path',{attrs:{"d":"M23.16 30.13h-2.32v2.32H16.2v2.32h11.61v-2.32h-4.65zm10.45 2.32H29v2.32h4.64zm-18.61 0h-4.61v2.32H15zm18.61-11.61v4.64H10.39v-4.64zm2.33-2.32H8.07v9.29h27.87zm-4.65 5.8a1.16 1.16 0 111.16-1.16 1.16 1.16 0 01-1.16 1.16zm-3.48 0A1.16 1.16 0 1129 23.16a1.16 1.16 0 01-1.19 1.16zm-3.49 0a1.16 1.16 0 111.17-1.16 1.16 1.16 0 01-1.17 1.16zm-11.14-7h-2.79L15 9.23h14l4.64 8.13h-2.82l-3.09-5.81H16.28z"}}),_c('path',{attrs:{"d":"M44 44H0V0h44zM3 41h38V3H3z","fill":"#ffc504"}})])])
          )
        }
      }
    